(() => {
  const updateResearchButton = () => {
    const button = document.querySelector('.mx-hero__cta .mx-btn--outline');
    if (!button) return;

    button.textContent = 'Follow the Research';
    button.href = 'https://monolaurinresearch.com';
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', updateResearchButton, { once: true });
  } else {
    updateResearchButton();
  }
})();
